export default __webpack_public_path__ + "static/media/3.ee518c83.png";